var _title, _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgImageUpload = function SvgImageUpload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "21px",
    height: "21px",
    viewBox: "0 0 21 21",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "ico_imageUpload")), _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UI_Cashy",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ico_imageUpload",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11,3 L11,5 L2,5 L2,19 L16,19 L16,10 L18,10 L18,19 C18,20.1045695 17.1045695,21 16,21 L2,21 C0.8954305,21 0,20.1045695 0,19 L0,5 C0,3.8954305 0.8954305,3 2,3 L11,3 Z",
    id: "Combined-Shape",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18,-6.123234e-17 L18,3 L21,3 L21,5 L18,5 L18,8 L16,8 L16,5 L13,5 L13,3 L16,3 L16,6.123234e-17 L18,-6.123234e-17 Z",
    id: "Combined-Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.54502846,16 L6.9704555,16 L6.23619234,15.3576859 L5.54502846,16 Z M8.55528294,16 L13.0393731,16 L11.2286779,13.5034982 L8.55528294,16 Z",
    id: "Path-34",
    stroke: "#000000",
    strokeWidth: 2
  })))));
};
export default SvgImageUpload;